export default function Footer(){

    return <footer className="py-1 bg-dark">
                <p className="text-center text-white mt-1 ">
                Y-Not-Kart @2024, All Rights Reserved
                </p>
            </footer>
}